import { Box, Stack } from '@mui/material';
import { AddPaperCard, FormAutoSaveTypography } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface IAddCaseDetails {
  append: () => void;
  save: () => Promise<void>;
}

export const AddCaseDetail = (props: IAddCaseDetails) => {
  return (
    <>
      <Stack>
        <AddPaperCard
          add={props.append}
          label={Dictionary[DICTIONARY.CASE_DETAILS].secondaryPaperFormTitle}
          secondaryLabel={
            Dictionary[DICTIONARY.CASE_DETAILS].secondaryPaperFormSubTitle
          }
        />
      </Stack>
      <Box mt={3}>
        <FormAutoSaveTypography save={props.save} />
      </Box>
    </>
  );
};
